import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { SystemSteps } from './components/SystemSteps';
import { Included } from './components/Included';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyBar } from './components/StickyBar';
export function App() {
  return <div className="w-full bg-ink-950 pb-20 sm:pb-0" data-id="element-0" data-mp="2mjzp7bw1w1pq">
      <Hero data-id="element-1" data-mp="31bi9vmzuukff" />
      <main data-id="element-2" data-mp="31c1hoavsjsfq">
        <PainPoints data-id="element-3" data-mp="31ctflscv2296" />
        <SystemSteps data-id="element-4" data-mp="2wk06ksad07ra" />
        <Included data-id="element-5" data-mp="2wjqhd6x524mn" />
        <Bonuses data-id="element-6" data-mp="2wj8dbo48im46" />
        <Testimonials data-id="element-7" data-mp="2wip54z4dzc3c" />
        <Pricing data-id="element-8" data-mp="2wi5qbra193tj" />
        <Faq data-id="element-9" data-mp="28u5uwe1s0p8m" />
        <FinalCta data-id="element-10" data-mp="28tmdcyg1g2v4" />
      </main>
      <Footer data-id="element-11" data-mp="28suv0pbgc1ms" />
      <StickyBar data-id="element-12" data-mp="28sb9yzqi8x4j" />
    </div>;
}